import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {getTransactionsService} from "./transactions.service";
import type {TransactionsFilter, TransactionsResult} from "./transactions.types";

export const TRANSACTIONS_QUERY_KEY = "transactions" as const;

export interface UseTransactionsResult {
  data: TransactionsResult | undefined;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useTransactions = (filter: TransactionsFilter): UseTransactionsResult => {
  const query = useQuery<TransactionsResult, Error>({
    queryKey: [TRANSACTIONS_QUERY_KEY, filter],
    queryFn: () => getTransactionsService(filter),
    staleTime: 0,
    placeholderData: keepPreviousData,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
